// extracted by mini-css-extract-plugin
export default {"container":"IZ5Et","title":"_2ef9p","text":"I3qfF","button":"Fb4nM"};